import React, { useContext, useEffect, useState } from 'react';
import { Button } from 'web-store-modules/packages/web-store-ui-library';
import { AddToCartContext } from './AddToCartContext';
import { WishlistBookAppointmentClicked } from '../../../utils/Analytics';
import { getStoreId, singaporeStoreId } from '../../../utils/StoreConfigManager';

const bookIcon = "https://cdn.obsess-vr.com/fendi/book-appointment-final.svg";
const appointmentLink = singaporeStoreId === getStoreId() ? "https://www.fendi.com/sg-en/book-appointment?storeID=1105&utm_source=ObsessVR&utm_medium=referral&utm_campaign=SGMBS_Virtual_Store" : "https://www.fendi.com/us/info/customer-care/book-appointment/book-appointment-form?type=appointment&storeId=004001&UTM_Source=ObsessVR&UTM_Campaign=NYC57_Virtual_Store&UTM_Medium=referral";
const CartDropdownFooter = ({ onClick }) => {
    const { colors, buttonFields } = useContext(AddToCartContext);

    const handleClick = () => {
        const sceneName = window.location.href.split('/').pop();
        WishlistBookAppointmentClicked(sceneName);
    }

    return (
        <a
            className="call-to-order-btn-wrapper dark-bg margin15-auto hoverable"
            style={{ margin: '8px auto' }}
            href={appointmentLink}
            target="_blank"
            onClick={handleClick}
        >
            <img src={bookIcon} />
            <span className="call-to-order-btn">Book an appointment</span>
        </a>
    )
}

export default CartDropdownFooter;
